export default __webpack_public_path__ + "static/media/dataproc.621255fe.svg";